export interface IUserInfo {
  name?: string
  email?: string
  firstName?: string
  lastName?: string
  id: string
  image?: string
}

export const ProductsSubAppName: typeof import('@prisma/client').$Enums.SubLogAppName =
  {
    App1: 'App1',
  }

export const ProductsSubUsageType: typeof import('@prisma/client').$Enums.ProductsSubUsageType =
  {
    credits: 'credits',
  }

export const PaymentPlatformPlatformName: typeof import('@prisma/client').$Enums.PaymentPlatformPlatformName =
  {
    Stripe: 'Stripe',
    Paypal: 'Paypal',
    Fastspring: 'Fastspring',
    Payinsider: 'Payinsider',
    Apple: 'Apple',
    Google: 'Google',
  }

export type TPlatFormName =
  (typeof PaymentPlatformPlatformName)[keyof typeof PaymentPlatformPlatformName]

export enum ECredentialsProviderType {
  /**
   * 匿名用户
   */
  AnonymousUser = 'anonymous-user',
  /**
   * 系统用户（登录注册用户）
   */
  SystemUser = 'system-user',
}

export enum AudioType {
  // 音乐
  Music = 'music',
  // 音效
  SoundEffect = 'soundEffect',
}
